/**
 * Setup and How-To's strings (piece 15; decision 1842), kept beside its list
 * and spread into the one lookup in `strings.ts`. 🔨 This file imports
 * nothing, because the lookup imports it.
 */
export const SETUP_GUIDES_STRINGS = {
  'setupGuides.title': 'Setup and How-To',
  'setupGuides.hint': 'Every setup guide in the application and how far each has got. A step ticks itself once what it asks for is saved; open a guide to carry on where it stands.',
  'setupGuides.perRecord': 'Each one runs again for every record it is about, so it has no count of its own here.',
  'setupGuides.stepsDone': 'steps done',
  'setupGuides.of': 'of',
  'setupGuides.steps': 'steps',
  'setupGuides.noCount': 'Open the guide to see its steps.',
  'setupGuides.allDone': 'Done',
  'setupGuides.open': 'Open',
  'setupGuides.import.title': 'Zoho Books Import',
  'setupGuides.import.what': 'Brings the old books in from Zoho Books, block by block, to the go-live sign-off.',
  'setupGuides.backups.title': 'Backups',
  'setupGuides.backups.what': 'The office and cloud mirrors, the nightly dump, the master key’s recovery copy and the monthly restore rehearsal.',
  'setupGuides.accounting.title': 'Set Up Accounting',
  'setupGuides.accounting.what': 'What stock is costed at, the reporting basis and the opening balances.',
  'setupGuides.bank.title': 'Connect a Bank',
  'setupGuides.bank.what': 'From the feed keys to the first closed reconciliation.',
  'setupGuides.mail.title': 'Set Up Company Mail',
  'setupGuides.mail.what': 'The domain’s records, the mailbox host, the shared mailboxes and the first message sent.',
  'setupGuides.logins.title': 'Turn on Logins',
  'setupGuides.logins.what': 'From the break-glass login alone to everyone signing in through the identity provider.',
  'setupGuides.firstHire.title': 'First Hire',
  'setupGuides.firstHire.what': 'What a hire at our own company needs first: an email domain, a site of ours, a job role and the employment rules of the site’s state.',
  'setupGuides.state.title': 'Set Up a State',
  'setupGuides.state.what': 'Opens from a state on Sales Tax: the registration, its filing frequency, the rate, what it taxes, local rates and the nexus warning.',
  'setupGuides.exemptCustomer.title': 'Exempt Customer',
  'setupGuides.exemptCustomer.what': 'Opens from a site’s Tax Exempt Certificates tile: find the state’s form, request or record it, check it and confirm it.',
  'setupGuides.fileReturn.title': 'File and Pay a Return',
  'setupGuides.fileReturn.what': 'Opens from a return not yet paid on Sales Tax: review, the figures, the filing and the payment.',
} as const;
